const isFieldRequiredLabel = (
  requiredFieldsPerBlock,
  block,
  field,
  label,
  index,
) => {
  if (!requiredFieldsPerBlock || !block || !field) {
    return label;
  }
  return requiredFieldsPerBlock[block].find(requiredField => {
    const fieldSplit = requiredField?.split('.');

    let fieldToCheck = field;
    if (typeof index !== 'number') {
      if (fieldSplit?.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        fieldToCheck = fieldSplit[0];
      } else if (fieldSplit?.length > 1) {
        fieldToCheck = fieldSplit[fieldSplit.length - 1];
      }
    } else {
      fieldToCheck = fieldSplit[index];
    }
    return fieldToCheck === field;
  })
    ? `${label}*`
    : label;
};

const getValidationRules = (
  requiredFields,
  block,
  validationRules = {},
  extraValidation = {},
  index = null,
) => {
  const newValidationRules = { ...validationRules };
  const requiredBlockFields = requiredFields[block] || [];

  requiredBlockFields.forEach(field => {
    const fieldSplit = field?.split('.');
    let requiredField = field;
    if (typeof index !== 'number') {
      if (fieldSplit?.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        requiredField = fieldSplit[0];
      } else if (fieldSplit?.length > 1) {
        requiredField = fieldSplit[fieldSplit.length - 1];
      }
    } else {
      requiredField = fieldSplit[index];
    }

    if (!extraValidation) {
      newValidationRules[requiredField] = { required: true };
    } else {
      newValidationRules[requiredField] = {
        required: true,
        ...extraValidation,
      };
    }
  });

  return newValidationRules;
};

const validateObject = obj => {
  // Check if it's an array
  if (Array.isArray(obj)) {
    // Validate based on array length
    return obj?.length === 0;
  }
  // Validate based on object keys
  return Object.keys(obj)?.length === 0;
};

const getErrors = (validationRules, state) => {
  const newErrors = {};
  Object.keys(validationRules || {}).forEach(field => {
    const isRequired = validationRules[field]?.required;

    if (isRequired && state[field] && typeof state[field] === 'object') {
      newErrors[field] = validateObject(state[field]);
    } else if (isRequired && (!state[field] || state[field]?.length === 0)) {
      newErrors[field] = true;
    }
  });

  return newErrors;
};

const checkIfHasErrors = errors =>
  Object.values(errors).find(err => err === true);

export {
  isFieldRequiredLabel,
  getValidationRules,
  getErrors,
  checkIfHasErrors,
};
